export type HelpPublication = {
	citation: string;
	href: string;
};

export const helpCenterPublicationsIntro =
	"Please find below a non-exhaustive list of publications related to EX-ACT:";

export const helpCenterPublications: HelpPublication[] = [
	{
		citation:
			"Guzmán Estrada, I., Orozalieva, A., Drogo, F., & Maestripieri, L. 2026. Integrating permanence into greenhouse gas accounting for agrifood systems - Application of the Environmental eXternalities ACcounting Tool (EX-ACT). Rome, FAO.",
		href: "https://doi.org/10.4060/cd9823en",
	},
	{
		citation:
			"Dobrovich, G., Orozalieva, A., Mamidanna, S., Saludas, M. & Maestripieri, L. 2026. Additionality and ex ante greenhouse gas project level accounting - Application of the Environmental eXternalities ACcounting Tool (EX-ACT). Rome, FAO.",
		href: "https://doi.org/10.4060/cd8389en",
	},
	{
		citation:
			"Orozalieva, A. & Maestripieri, L. 2026. Environmental eXternalities ACcounting Tool (EX-ACT) - User guide. Rome.",
		href: "https://doi.org/10.4060/cd8682en",
	},
	{
		citation:
			"FAO. 2025. Checklist for EX-ACT implementation.",
		href: "https://openknowledge.fao.org/handle/20.500.14283/cd7207en",
	},
	{
		citation:
			"Maestripieri, L., Gokhale, S., Snyder, H.T. & Ilicic, J. 2025. Expanding greenhouse gas accounting in the fisheries sector using the Environmental eXternalities ACcounting Tool (EX-ACT) - Review of the \"Coastal and Marine Fisheries Management\" module of EX‐ACT. Rome, FAO.",
		href: "https://doi.org/10.4060/cd6232en",
	},
	{
		citation:
			"Crespi, M.G., Maestripieri, L. & Ilicic, J. 2025. Greenhouse gas accounting in the forestry sector - Refining the approach for forest management activities in EX-ACT. Rome, FAO.",
		href: "https://doi.org/10.4060/cd4515en",
	},
	{
		citation:
			"Ilicic, J., Maestripieri, L., Dobrovich, G., Ignaciuk, A. & Rottem, A. 2024. Making public investments Paris Agreement-aligned in a cost-effective way - Calculating marginal abatement cost curves for agricultural investments. FAO Agricultural Development Economics Working Paper, 24-02. Rome, FAO.",
		href: "https://doi.org/10.4060/cd0779en",
	},
	{
		citation:
			"Zhong, H., Li, Y., Ding, J. et al. Global spillover effects of the European Green Deal and plausible mitigation options. Nat Sustain 7, 1501-1511 (2024).",
		href: "https://doi.org/10.1038/s41893-024-01428-1",
	},
	{
		citation:
			"Arun Khatri-Chhetri, Ciniro Costa Junior, Eva Wollenberg, Greenhouse gas mitigation co-benefits across the global agricultural development programs, Global Environmental Change, 2022.",
		href: "https://doi.org/10.1016/j.gloenvcha.2022.102586",
	},
	{
		citation:
			"Adounkpe, J., Ahoudji, O. and Sinsin, B. (2021) Assessment of the Contribution of Flooded Rice Cultivation Systems to Methane Emissions in the Lower Ouémé Valley, in Benin Republic. Journal of Agricultural Chemistry and Environment, 10, 327-344.",
		href: "https://doi.org/10.4236/jacen.2021.103021",
	},
	{
		citation:
			"Francis Molua Mwambo, Christine Fürst, Christopher Martius, Marcos Jimenez-Martinez, Benjamin Kofi Nyarko, Christian Borgemeister, Combined application of the EM-DEA and EX-ACT approaches for integrated assessment of resource use efficiency, sustainability and carbon footprint of smallholder maize production practices in sub-Saharan Africa, Journal of Cleaner Production, Volume 302, 2021.",
		href: "https://doi.org/10.1016/j.jclepro.2021.126132",
	},
	{
		citation:
			"Srinivasa Rao, Ch., Girija Veni, V., Prasad, J. V. N. S., Sharma, K. L., Chandrasekhar, Ch., Rohilla, P. P., & Singh, Y. V. (2017). Improving carbon balance with climate-resilient management practices in tropical agro-ecosystems of Western India. Carbon Management, 8(2), 175-190.",
		href: "https://doi.org/10.1080/17583004.2017.1309202",
	},
	{
		citation:
			"Richards, M., Metzel, R., Chirinda, N. et al. Limits of agricultural greenhouse gas calculators to predict soil N2O and CH4 fluxes in tropical agriculture. Sci Rep 6, 26279 (2016).",
		href: "https://doi.org/10.1038/srep26279",
	},
	{
		citation:
			"Srinivasarao, C., Sudha Rani, Y., Girija Veni, V. et al. Assessing village-level carbon balance due to greenhouse gas mitigation interventions using EX-ACT model. Int. J. Environ. Sci. Technol. 13, 97-112 (2016).",
		href: "https://doi.org/10.1007/s13762-015-0788-z",
	},
];
